import React from "react";

import QuestionImageItem from "./QuestionImageItem";

const QuestionImageList = ({ questions = [] }) => {
  if (!questions.length) {
    return (
      <div className="bg-white rounded-xl shadow border border-gray-200 p-6">
        <p className="text-center text-gray-500">
          No questions require images for this quiz.
        </p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Questions Requiring Images
      </h2>

      <div className="space-y-4">
        {questions.map((question) => (
          <QuestionImageItem
            key={question._id}
            question={question}
          />
        ))}
      </div>
    </div>
  );
};

export default QuestionImageList;